import * as React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Stat } from "./Stat";
import { useHomeData } from "./homeData";
import { useImpactData } from "./impactData";

export const Numbers = ({ displayData }: { displayData: "impact" | "home" }) => {
  const homeData = useHomeData();
  const impactData = useImpactData();

  const dataToDisplay = displayData === "impact" ? impactData : homeData;

  return (
    <Box>
      <Flex overflow="visible" whiteSpace="nowrap" flexFlow={{ base: "column", md: "row" }}>
        {dataToDisplay.map((item: any, index: number) => (
          <Stat
            key={index}
            number={displayData === "impact" ? item.number : item.homeNumber}
            title={displayData === "impact" ? item.title : item.homeTitle}
            isFirstLink={index === 0}
          />
        ))}
      </Flex>
    </Box>
  );
};
